module.exports = __webpack_public_path__ + "img/pause.e807ca5f.svg";